export default {
	leads         : {},
	count         : 0,
	page          : 1,
	perPage       : 10,
	search        : '',
	filterOptions : {
		sites     : [],
		campaigns : [],
		tags      : [],
	},
	filters : {
		sites          : [],
		campaigns      : [],
		tags           : [],
		dateRangeStart : null,
		dateRangeEnd   : null,
	},
	export : {
		first_name  : true,
		last_name   : true,
		email       : true,
		phone       : true,
		campaign    : true,
		site        : true,
		site_domain : true,
		page_title  : true,
		page_url    : true,
		ip          : true,
		date        : true,
		time        : true,
		type        : 'xlsx',
	},
}
